import React from 'react';
import TabbedPage from '../../../Elements/TabbedPage';
import ThirdPartyJobPaymentsAdmin from './ThirdPartyJobPayments/ThirdPartyJobPaymentsAdmin';
import VoidedThirdPartyJobPaymentsAdmin from './ThirdPartyJobPayments/VoidedThirdPartyJobPaymentsAdmin';
import ExcludedTpJobPayEvaluatorsAdmin from './ThirdPartyJobPayments/ExcludedTpJobPayEvaluatorsAdmin';

export default class TpEvaluatorTpJobPaymentsAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      window: null,
    };
  }

  componentDidMount() {}

  tabs = [
    {
      label: 'Third-Party Job Payments',
      id: 'thirdpartyjobpayments',
      icon: 'fa-solid fa-credit-card',
      component: <ThirdPartyJobPaymentsAdmin />,
    },
    {
      label: 'Voided Payments',
      id: 'voidedtppayments',
      icon: 'fa-solid fa-credit-card',
      component: <VoidedThirdPartyJobPaymentsAdmin />,
    },
    {
      label: 'Excluded PS',
      id: 'excludedtpevaluators',
      icon: 'fa-solid fa-memo-circle-info',
      component: <ExcludedTpJobPayEvaluatorsAdmin />,
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.window}
        <div className='bg-white p-1'>
          <div className='TabbedPage'>
            <TabbedPage
              tabs={this.tabs}
              removeSearchParametersOnTabChange={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
